const de = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    create: "Erstellen",
    close: "Schließen",
    back: "Zurück",
    next: "Weiter",
    loading: "Laden...",
    saving: "Speichern...",
    confirm: "Bestätigen",
    yes: "Ja",
    no: "Nein",
    all: "Alle",
    none: "Keine",
    error: "Fehler",
    success: "Erfolg",
    refresh: "Aktualisieren",
    logout: "Abmelden",
    dashboard: "Dashboard",
    settings: "Einstellungen",
    profile: "Profil",
    today: "Heute",
    noData: "Keine Daten",
    copied: "Kopiert",
    required: "Erforderlich",
    optional: "Optional",
    minutes: "Minuten",
    search: "Suche",
  },
  auth: {
    welcome: "Willkommen",
    loginSubtitle: "Melde dich bei deinem EVA AI Konto an",
    email: "E-Mail",
    password: "Passwort",
    login: "Anmelden",
    loggingIn: "Anmeldung...",
    forgotPassword: "Passwort vergessen?",
    forgotPasswordTitle: "Passwort vergessen?",
    forgotPasswordDesc: "Gib deine E-Mail ein, um einen Reset-Link zu erhalten",
    enterEmail: "Bitte gib deine E-Mail ein",
    resetLinkSent: "Wenn die E-Mail existiert, erhältst du einen Reset-Link",
    resetLinkSentLong: "Wenn die E-Mail in unserem System existiert, erhältst du innerhalb weniger Minuten einen Reset-Link. Prüfe auch den Spam-Ordner.",
    sendError: "Fehler beim Senden",
    sending: "Wird gesendet...",
    sendResetLink: "Reset-Link senden",
    backToLogin: "Zurück zum Login",
    setNewPassword: "Neues Passwort festlegen",
    setNewPasswordDesc: "Gib dein neues Passwort ein",
    passwordResetSuccess: "Passwort erfolgreich zurückgesetzt!",
    tokenInvalid: "Ungültiger oder abgelaufener Token",
    invalidLink: "Ungültiger Link. Bitte fordere einen neuen Reset-Link an.",
    requestNewLink: "Neuen Link anfordern",
    updating: "Aktualisiere...",
    noAccount: "Noch kein Konto?",
    signup: "Registrieren",
    emailRequired: "E-Mail und Passwort sind erforderlich",
    loginSuccess: "Erfolgreich angemeldet!",
    invalidCredentials: "Ungültige Anmeldedaten",
    signupTitle: "Konto erstellen",
    signupSubtitle: "Registriere dein EVA AI Konto",
    tenantName: "Studio-/Firmenname",
    confirmPassword: "Passwort bestätigen",
    passwordMismatch: "Passwörter stimmen nicht überein",
    passwordTooShort: "Das Passwort muss mindestens 8 Zeichen haben",
    allFieldsRequired: "Alle Felder sind erforderlich",
    signupSuccess: "Konto erfolgreich erstellt!",
    signingUp: "Registrierung...",
    hasAccount: "Bereits ein Konto?",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmNewPassword: "Neues Passwort bestätigen",
    changePassword: "Passwort ändern",
    changingPassword: "Aktualisierung...",
    passwordChanged: "Passwort aktualisiert",
    minChars: "Mindestens 8 Zeichen",
    wrongCurrentPassword: "Aktuelles Passwort ist falsch",
    fillAllFields: "Bitte alle Felder ausfüllen",
  },
  verifyEmail: {
    title: "E-Mail bestätigen",
    checking: "E-Mail wird bestätigt...",
    successTitle: "E-Mail bestätigt",
    successDesc: "Deine E-Mail-Adresse wurde erfolgreich bestätigt.",
    invalidTitle: "Bestätigung fehlgeschlagen",
    invalidDesc: "Dieser Bestätigungslink ist ungültig oder abgelaufen. Du kannst im Dashboard einen neuen anfordern.",
    missingToken: "Der Bestätigungstoken fehlt in diesem Link.",
    goToDashboard: "Zum Dashboard",
    goToLogin: "Zum Login",
    bannerTitle: "E-Mail bestätigen",
    bannerDesc: "Bestätige deine E-Mail, damit du dein Konto wiederherstellen und wichtige Servicehinweise erhalten kannst.",
    resend: "Bestätigungs-E-Mail erneut senden",
    sending: "Wird gesendet...",
    sent: "Bestätigungs-E-Mail gesendet. Prüfe deinen Posteingang.",
    sendError: "Die Bestätigungs-E-Mail konnte nicht gesendet werden. Versuche es später erneut.",
  },

  dashboard: {
    completeSetup: "Einrichtung abschließen",
    activateSubscription: "Aktiviere dein Abo, um EVA AI zu nutzen.",
    configureWhatsApp: "Konfiguriere WhatsApp, um Nachrichten zu empfangen.",
    startSetup: "Setup starten",
    subscription: "Abonnement",
    founderPlan: "Founder-Plan mit vollem Zugriff",
    monthlyActive: "99 CHF/Monat - Aktiv",
    setupRequired: "Einrichtung erforderlich",
    activateBtn: "Abonnement aktivieren",
    whatsapp: "WhatsApp",
    phoneNumber: "Nummer",
    notSpecified: "Nicht angegeben",
    notConfigured: "Keine Konfiguration vorhanden",
    configure: "Konfigurieren",
    messages: "Nachrichten",
    lastMessages: "Letzte empfangene Nachrichten",
    evaStatus: "EVA Status",
    evaActive: "Eva Aktiv",
    evaPaused: "Eva Pausiert",
    autoResponses: "Automatische Antworten",
    quickPause: "Schnellpause",
    pausedFor: "Eva pausiert für {minutes} Minuten",
    evaReactivated: "Eva reaktiviert",
    languageControl: "Sprachsteuerung",
    languageControlDesc: "Standardsprache festlegen und für alle Kontakte erzwingen",
    defaultLanguage: "Standardsprache",
    forceLanguage: "Sprache global erzwingen",
    forceLanguageOn: "Alle Kontakte erhalten Antworten in dieser Sprache",
    forceLanguageOff: "Eva erkennt die Sprache automatisch",
    saveLanguage: "Sprachsteuerung speichern",
    languageSaved: "Sprachsteuerung gespeichert",
    quickActions: "Schnellaktionen",
    openInbox: "Inbox öffnen",
    calendar: "Kalender",
    setupWizard: "Setup-Assistent",
    refreshData: "Daten aktualisieren",
    recentMessages: "Letzte Nachrichten",
    recentMessagesDesc: "Letzte 10 empfangene Nachrichten",
    noMessages: "Noch keine Nachrichten",
    noMessagesHint: "Nachrichten erscheinen hier, wenn du Anfragen erhältst",
    contact: "Kontakt",
    direction: "Richtung",
    message: "Nachricht",
    language: "Sprache",
    date: "Datum",
    received: "Empfangen",
    sent: "Gesendet",
    subscriptionActivated: "Abonnement aktiviert",
    checkoutReceived: "Checkout empfangen, Prüfung...",
    dataLoadError: "Fehler beim Laden der Daten",
    statusUpdateError: "Fehler beim Aktualisieren des Status",
    pauseError: "Fehler beim Pausieren",
    languageSaveError: "Fehler beim Speichern",
    contactLanguageUpdated: "Kontaktsprache aktualisiert",
    contactLanguageError: "Fehler beim Aktualisieren",
    active: "Aktiv",
    pastDue: "Zahlung überfällig",
    canceled: "Gekündigt",
    incomplete: "Unvollständig",
    connected: "Verbunden",
  },
  calendar: {
    title: "Terminkalender",
    confirmed: "bestätigt",
    pending: "ausstehend",
    blocked: "blockiert",
    arriving: "ankommend",
    noAppointments: "Keine Termine",
    noAppointmentsDay: "Keine Termine für diesen Tag",
    newAppointment: "Neu",
    blockSlot: "Blockieren",
    girlFilter: "Dame",
    statusFilter: "Status",
    allGirls: "Alle",
    activeFilter: "Aktiv",
    confirmedFilter: "Bestätigt",
    pendingFilter: "Ausstehend",
    blockedFilter: "Blockiert",
    completedFilter: "Abgeschlossen",
    appointmentDetail: "Termindetails",
    blockedSlot: "Blockierter Slot",
    girl: "Dame",
    dateLabel: "Datum",
    time: "Uhrzeit",
    duration: "Dauer",
    whatsappLabel: "WhatsApp",
    buzzer: "Klingel",
    notes: "Notizen",
    dateTime: "Datum/Uhrzeit",
    status: "Status",
    arrivalStatus: "Ankunftsstatus",
    noChanges: "Keine Änderungen",
    appointmentUpdated: "Termin aktualisiert",
    deleted: "Gelöscht",
    newAppointmentTitle: "Neuer Termin",
    girlRequired: "Dame und Datum/Uhrzeit sind erforderlich",
    appointmentCreated: "Termin erstellt",
    clientPhone: "WhatsApp Kundin",
    languageOptional: "Sprache",
    buzzerOptional: "Klingel",
    createAppointment: "Termin erstellen",
    creating: "Erstelle...",
    blockSlotTitle: "Slot blockieren",
    blockDuration: "Dauer",
    blockReason: "Grund / Notizen",
    blockReasonPlaceholder: "z.B.: Pause, nicht verfügbar, etc.",
    blockSubmit: "Slot blockieren",
    blocking: "Blockiere...",
    slotBlocked: "Slot blockiert",
    loadError: "Fehler beim Laden der Termine",
    blocked_label: "BLOCKIERT",
  },
  settings: {
    title: "EVA AI - Einstellungen",
    whatsappConfig: "WhatsApp-Konfiguration",
    whatsappConfigDesc: "WhatsApp Business API-Zugangsdaten verwalten",
    webhookUrl: "Webhook-URL",
    phoneNumberId: "Phone Number ID",
    accessToken: "Access Token",
    accessTokenStored: "Token gespeichert",
    accessTokenStoredHint: "Der Token ist sicher gespeichert. Du musst ihn nicht erneut eingeben.",
    replaceAccessToken: "Token ersetzen",
    replaceAccessTokenHint: "Gib nur dann einen neuen Token ein, wenn du den gespeicherten ersetzen möchtest.",
    accessTokenRequiredHint: "Gib den Meta-Token ein. Nach dem Speichern bleibt er sicher gespeichert.",
    verifyToken: "Verify Token",
    phoneNumber: "Telefonnummer",
    saveWhatsApp: "WhatsApp-Konfiguration speichern",
    whatsappSaved: "WhatsApp-Konfiguration gespeichert",
    generalSettings: "Allgemeine Einstellungen",
    generalSettingsDesc: "Verhalten von EVA AI anpassen",
    defaultLanguage: "Standardsprache",
    forceLanguage: "Sprache global erzwingen",
    forceLanguageDesc: "Automatische Erkennung überschreiben und immer diese Sprache verwenden",
    forcedLanguage: "Erzwungene Sprache",
    durations: "Dauer (Minuten, kommagetrennt)",
    externalDetailsLink: "Externer Details-Link (Compliance)",
    pricingText: "Preistext",
    rules: "Regeln",
    locationInfo: "Standortinformationen",
    welcomeMessage: "Begrüßungstext",
    saveSettings: "Einstellungen speichern",
    settingsSaved: "Einstellungen gespeichert",
    studioConfig: "Studio-Konfiguration",
    studioConfigDesc: "Öffentliche Einstellungen für Infos und Buchungen",
    studioName: "Studioname",
    publicInfoUrl: "Offizieller Link (Services/Preise/Damen)",
    publicInfoUrlWarning: "Ohne gültigen Link (http:// oder https://) kann EVA den Link für Services/Preise/Damen nicht senden. Sie antwortet trotzdem freundlich und leitet zur Buchung, aber ohne den Link zu teilen.",
    publicInfoUrlHint: "Dieser Link wird für Anfragen zu Services, Preisen und Damen verwendet",
    girlsList: "Damen (eine pro Zeile)",
    girlsListHint: "Bei mehr als einer Dame fragt EVA nach. Bei nur einer erfolgt automatische Auswahl.",
    saveStudio: "Studio-Konfiguration speichern",
    saveError: "Fehler beim Speichern",
    loadError: "Fehler beim Laden der Daten",
    urlCopied: "URL kopiert",
  },
  wizard: {
    title: "EVA AI Einrichtung",
    stepOf: "Schritt {step} von {total}",
    billingTitle: "Abonnement",
    billingDesc: "Aktiviere dein monatliches Abo, um EVA AI zu nutzen",
    founderTitle: "Internal Plan (Founder)",
    founderDesc: "Du hast vollen Zugriff auf alle Funktionen ohne Abo.",
    founderHint: "Du kannst direkt mit der WhatsApp-Konfiguration fortfahren.",
    subscriptionActive: "Abo aktiv! Du kannst mit der Konfiguration fortfahren.",
    standardPlan: "Standard Plan",
    standardPlanDesc: "Alles inklusive, keine Bindung",
    perMonth: "pro Monat",
    featureWhatsApp: "WhatsApp Cloud API Integration",
    featureMultilang: "Mehrsprachig (IT/DE/EN/ES)",
    featureBooking: "FSM Buchungs-Engine",
    featureDashboard: "Dashboard und Analytics",
    activateSubscription: "Abo aktivieren",
    activating: "Checkout wird geöffnet...",
    stripeRedirect: "Du wirst zu Stripe weitergeleitet, um die Zahlung sicher abzuschließen.",
    privatePilotBilling: "EVA befindet sich in einem privaten Pilotbetrieb: Abonnements und Belastungen sind deaktiviert, bis der Dienst für den Verkauf geöffnet wird.",
    privatePilotClosed: "Zahlungen während des Piloten geschlossen",
    whatsappTitle: "WhatsApp-Konfiguration",
    whatsappDesc: "Verbinde dein WhatsApp Business Konto",
    webhookUrl: "Webhook-URL",
    phoneNumberId: "Phone Number ID",
    phoneNumberIdHint: "Zu finden im Meta Business Manager → WhatsApp → API Setup",
    accessToken: "Access Token",
    verifyToken: "Verify Token",
    verifyTokenHint: "Verwende diesen von EVA bereitgestellten Wert, wenn Meta nach dem Webhook-Verify-Token fragt. Er wird von EVA verwaltet.",
    phoneNumber: "Telefonnummer",
    fillRequired: "Bitte alle Pflichtfelder ausfüllen",
    whatsappSaved: "WhatsApp-Konfiguration gespeichert",
    settingsTitle: "Einstellungen",
    settingsDesc: "Verhalten von EVA AI anpassen",
    defaultLanguage: "Standardsprache",
    durations: "Verfügbare Dauer (Minuten, kommagetrennt)",
    externalDetailsLink: "Externer Details-Link (WICHTIG für Compliance)",
    externalDetailsHint: "EVA leitet zu diesem Link weiter bei Medien oder expliziten Anfragen",
    pricingText: "Preistext",
    rules: "Regeln",
    locationInfo: "Standortinformationen",
    welcomeMessage: "Begrüßungstext",
    settingsSaved: "Einstellungen gespeichert",
    testTitle: "Testnachricht",
    testDesc: "Sende eine Testnachricht, um die Konfiguration zu prüfen",
    testAlmostDone: "Setup fast fertig! Sende eine Testnachricht, um alles zu bestätigen.",
    recipient: "Empfängernummer (internationales Format, ohne +)",
    recipientHint: "z.B.: 41791234567 für eine Schweizer Nummer",
    messageLabel: "Nachricht",
    sendTest: "Testnachricht senden",
    sending: "Wird gesendet...",
    testSent: "Testnachricht erfolgreich gesendet!",
    testCheckPhone: "Prüfe dein Telefon, um den Empfang zu bestätigen",
    fillRecipient: "Nummer und Nachricht eingeben",
    completeSetup: "Einrichtung abschließen",
    setupComplete: "Einrichtung abgeschlossen!",
    checkoutError: "Fehler beim Öffnen des Checkouts",
  },
  account: {
    title: "EVA AI - Profil",
    subscription: "Abonnement",
    subscriptionDesc: "Verwalte deinen Plan und dein Abo",
    plan: "Plan",
    status: "Status",
    nextRenewal: "Nächste Verlängerung",
    scheduledCancel: "Geplante Kündigung",
    cancelWarning: "Das Abo bleibt bis zum Ende des bereits bezahlten Zeitraums aktiv ({date}).",
    founderAlert: "Founder-Plan: unbegrenzter Zugang ohne Kosten.",
    price: "Preis",
    validUntil: "Gültig bis",
    scheduledCancelAlert: "Geplante Kündigung: Das Abo endet am Ende des laufenden Zeitraums.",
    cancelSubscription: "Abo kündigen (Periodenende)",
    cancelConfirmTitle: "Kündigung bestätigen?",
    cancelConfirmDesc: "Die Kündigung wird am Ende des bereits bezahlten Zeitraums wirksam. Der laufende Monat ist nicht erstattbar.",
    confirmCancel: "Kündigung bestätigen",
    canceling: "Kündigung...",
    cancelSuccess: "Kündigung geplant",
    cancelError: "Fehler bei der Kündigung",
    security: "Sicherheit",
    securityDesc: "Ändere das Passwort deines Kontos",
    active: "Aktiv",
    pastDue: "Zahlung überfällig",
    canceledStatus: "Gekündigt",
    incompleteStatus: "Unvollständig",
    founderInternal: "Founder / Internal",
    standard: "Standard",
    yourData: "Deine Daten",
    yourDataDesc: "Kontodaten exportieren oder unterstützte Löschung beantragen",
    dataLifecycleNotice: "Der Export enthält keine Passwörter, Anbieter-Zugangsdaten oder Kartendaten. Löschanträge werden geprüft und ohne unbelegte Fristversprechen bearbeitet.",
    downloadData: "Meine Daten herunterladen",
    dataExportSuccess: "Datenexport ist bereit",
    dataExportError: "Daten konnten nicht exportiert werden",
    requestDeletion: "Kontolöschung beantragen",
    deletionConfirmTitle: "Löschung beantragen?",
    deletionConfirmDesc: "Der Antrag wird zur betrieblichen Prüfung erfasst. Abonnement, rechtliche Pflichten, Drittanbieter und Backups müssen vor Abschluss bearbeitet werden.",
    deletionConfirmationLabel: "DELETE MY EVA ACCOUNT eingeben",
    submitDeletionRequest: "Antrag senden",
    deletionRequestSuccess: "Löschantrag wurde erfasst",
    deletionRequestError: "Antrag konnte nicht erfasst werden",
  },
  inbox: {
    title: "EVA AI - Inbox",
    conversations: "Gespräche",
    noConversations: "Keine Gespräche",
    noConversationsHint: "Gespräche erscheinen hier, wenn du Nachrichten erhältst",
    messagesLabel: "Nachrichten",
    lastActivity: "letzte Aktivität",
    typeMessage: "Nachricht schreiben...",
    send: "Senden",
    selectConversation: "Gespräch auswählen",
    selectConversationHint: "Wähle ein Gespräch aus der Liste, um Nachrichten zu sehen",
    messageSent: "Nachricht gesendet",
    messageSendError: "Fehler beim Senden der Nachricht",
    loadError: "Fehler beim Laden der Gespräche",
    messagesLoadError: "Fehler beim Laden der Nachrichten",
    eva: "EVA",
    client: "Kundin",
    manualMode: "Manuell",
    manualModeActive: "Manueller Modus aktiv. Eva antwortet nicht automatisch.",
    manualModeActivated: "Manueller Modus aktiviert",
    evaReactivated: "Eva reaktiviert",
    modeChangeError: "Fehler beim Moduswechsel",
    noMessages: "Keine Nachrichten",
    active: "Aktiv",
    optedOut: "Abgemeldet",
    now: "Jetzt",
    minutesAgo: "vor {n}m",
    hoursAgo: "vor {n}h",
    unreadNew: "neu",
    unreadNewPlural: "neue",
    contacts: "Kontakte",
    contact: "Kontakt",
  },
  languages: {
    it: "Italienisch",
    de: "Deutsch",
    en: "Englisch",
    es: "Spanisch",
    auto: "Auto",
  },
  signup: {
    title: "Konto erstellen",
    subtitle: "Starte mit EVA AI in wenigen Minuten",
    button: "Konto erstellen",
    creating: "Erstelle...",
    termsAccept: "Mit der Erstellung eines Kontos akzeptierst du unsere",
    termsOfService: "Nutzungsbedingungen",
    and: "und die",
    privacyPolicy: "Datenschutzrichtlinie",
    legalConsentPrefix: 'Ich akzeptiere die',
    legalConsentAndPrivacy: 'und bestätige, dass ich die folgende Richtlinie gelesen habe:',
    legalRequired: 'Zur Kontoerstellung musst du die aktuellen Bedingungen und den DPA akzeptieren und die Datenschutzerklärung bestätigen.',
    legalUnavailable: 'Die rechtlichen Informationen sind vorübergehend nicht verfügbar. Bitte lade die Seite neu.',
    nonCommercialLegal: 'Diese Umgebung ist noch nicht für die kommerzielle Nutzung konfiguriert; rechtliche Angaben fehlen.',
    privatePilotTitle: "Privater Pilot nur auf Einladung",
    privatePilotDesc: "Neue Registrierungen und Zahlungen sind vorübergehend geschlossen. Bereits eingeladene Nutzer können sich weiterhin anmelden und EVA testen.",
    privatePilotLogin: "Beim Pilot anmelden",
  },
  uiLanguage: {
    label: "Oberflächensprache",
    selectorTitle: "Sprache",
  },
  landing: {
    login: "Anmelden",
    startNow: "Jetzt starten",
    heroTitle1: "Der WhatsApp-Assistent",
    heroTitle2: "für die Buchungen deines Studios",
    heroSubtitle: "Automatisiere Buchungen, Kundenanfragen und Terminverwaltung über WhatsApp mit EVA AI. Mehrsprachig, konform und in wenigen Minuten einsatzbereit.",
    heroCta: "Jetzt starten",
    learnMore: "Mehr erfahren",
    featuresTitle: "Hauptfunktionen",
    featuresSubtitle: "Alles, was du brauchst, um Buchungen und Kundenanfragen über WhatsApp zu verwalten",
    feature1Title: "WhatsApp-Automatisierung",
    feature1Desc: "Automatischer Buchungsassistent für Termine und Kundenanfragen über WhatsApp.",
    feature2Title: "Mehrsprachig",
    feature2Desc: "Italienisch, Deutsch, Englisch und Spanisch mit konsistenter Sprachverwaltung.",
    feature3Title: "Intelligenter Buchungsmotor",
    feature3Desc: "Versteht natürliche Anfragen und verwaltet Buchungen mit Datum, Uhrzeit und Dauer zuverlässig.",
    feature4Title: "Integrierte Compliance",
    feature4Desc: "STOP/START-Verwaltung, Media-Redirect und Kontrolle sensibler Inhalte.",
    pricingTitle: "Einfach und klar",
    pricingSubtitle: "Ein Plan, alles inklusive",
    planName: "Standardplan",
    planPeriod: "pro Monat, ohne Bindung",
    bullet1: "WhatsApp Cloud API Integration",
    bullet2: "Mehrsprachig (IT/DE/EN/ES)",
    bullet3: "Intelligenter Buchungsmotor",
    bullet4: "Dashboard und Statistiken",
    bullet5: "GDPR/FADP-konform",
    privacy: "Datenschutz",
    terms: "AGB",
    dpa: "AVV",
  },
  alerts: {
    bookingCreated: "Neue Buchung",
    bookingUpdated: "Buchung geändert",
    bookingCancelled: "Buchung storniert",
    customerArrival: "Kundin kommt",
    manualModeMessage: "Nachricht (EVA aus)",
    girl: "Dame",
    time: "Uhrzeit",
    duration: "Dauer",
    client: "Kundin",
    source: "Quelle",
    whatsapp: "WhatsApp",
    manual: "Manuell",
    changed: "Geändert",
    unknown: "Unbekannt",
    phone: "Telefon",
    arrivalHelp: "Ankunftshilfe",
    soundOn: "Alert-Ton AN",
    soundOff: "Alert-Ton AUS",
    noAlerts: "Keine neuen Alerts",
    recentAlerts: "Letzte Alerts",
    clearAll: "Alle löschen",
    dismiss: "Entfernen",
    viewCalendar: "Kalender",
    viewInbox: "Posteingang",
    min: "Min",
    arrivalIncoming: "unterwegs",
    arrivalOutside: "vor Ort",
    arrivalAtDoor: "an der Tür",
    arrivalArrived: "angekommen",
  },
};

export default de;
